import { ISource } from 'src/interfaces/source';

/**
 * Group sources by area
 *
 * @param {ISource[]} sources
 * @return {*}
 */
export const groupSources = (sources: ISource[]) => {
    const digitalSources = sources
        .filter((s) => s.areas?.includes('digital'))
        .sort((a, b) =>
            a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
        );

    const showroomSources = sources
        .filter((s) => s.areas?.includes('showroom'))
        .sort((a, b) =>
            a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
        );

    const groupedSources = {
        digital: digitalSources,
        showroom: showroomSources,
    };

    return groupedSources;
};
